<div class="bfx-blotter-filter-list-table" [ngClass]="{tableDisabled: isInViewEditMode}">
  <p-dataTable
    #dt
    [value]="items"
    selectionMode="multiple"
    [(selection)]="selection"
    sortMode="multiple"
    [(multiSortMeta)]="multiSortMeta"
    scrollable="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="filterName"
    [emptyMessage]="emptyMessage"
    tableStyleClass="bfx-blotter__filter-manager__table"
    styleClass="bfx-blotter__filter-manager__styleclass"
    [rowStyleClass]="applyFavoriteStyle"
  >
    <p-column
      field="favorite"
      sortField="favorite"
      styleClass="favorite-column"
      header="Fav"
      [style]="{'width':'45px', 'text-align' : 'center'}"
      [sortable]="true"
    >
      <ng-template let-data="rowData" pTemplate="body">
        <i
          [ngClass]="{ 'icon icon-ion_favorite_filled': data.favorite, 'icon icon-ion_favorite': !data.favorite}"
          (click)="toggleFavorite(data);"
        ></i>
      </ng-template>
    </p-column>
    <p-column
      #ftname
      field="filterName"
      sortField="filterName"
      header="Filter Name"
      [filter]="filter"
      [style]="{'width':'134px'}"
      filterMatchMode="contains"
      [sortable]="true"
    >
      <ng-template let-data="rowData" pTemplate="body">
        <span [title]="data.filterName.length > 20 ? data.filterName : ''"
          >{{data.filterName}}</span
        >
      </ng-template>
    </p-column>
    <p-column
      #ftcreateBy
      field="createdBy"
      sortField="createdBy"
      header="Created By"
      [filter]="filter"
      [style]="{'width':'133px'}"
      filterMatchMode="contains"
      [sortable]="true"
    ></p-column>
    <p-column
      #ftUpdate
      field="createDate"
      sortField="createDateVal"
      header="Last Updated"
      [filter]="filter"
      [style]="{'width':'134px'}"
      filterMatchMode="contains"
      [sortable]="true"
    ></p-column>
    <p-column styleClass="bfx-blotter-filter-list-table-search" [style]="{'width':'54px'}">
      <ng-template pTemplate="header">
        <div class="bfx-button-secondary-subtle" (click)="filter = onClickFilterSearch(filter, dt)">
          <label class="icon icon-search" fxFill></label>
        </div>
      </ng-template>
      <ng-template let-data="rowData" pTemplate="body"></ng-template>
    </p-column>
  </p-dataTable>
</div>
<div class="button-line" [ngClass]="{itemDisabled: isInViewEditMode}">
  <p-selectButton
    [options]="filterSelectionModes"
    [(ngModel)]="filterSelection"
    [tabindex]="-1"
  ></p-selectButton>
</div>
<div class="divider"></div>
<div class="bottom-bar" [ngClass]="{itemDisabled: isInViewEditMode}">
  <button
    class="bfx-button-secondary"
    [disabled]="isInViewEditMode"
    (click)="createNewFilter()"
    [tabindex]="isInViewEditMode?-1:0"
  >
    New
  </button>
  <button
    class="bfx-button-secondary"
    [disabled]="selection.length != 1 || hasUnrestrictedRights === false || (selection.length == 1 && selection[0].system)"
    (click)="editItemFromButton()"
    [tabindex]="isInViewEditMode?-1:0"
  >
    Edit
  </button>
  <button
    class="bfx-button-secondary"
    [disabled]="selection.length != 1 || (selection.length == 1 && selection[0].system)"
    (click)="copyFilter($event)"
    [tabindex]="isInViewEditMode?-1:0"
  >
    Copy
  </button>
  <button
    class="bfx-button-secondary"
    [disabled]="selection.length == 0 || hasUnrestrictedRights === false || (selection.length == 1 && selection[0].system)"
    (click)="confirmDeleteFilters()"
    [tabindex]="isInViewEditMode?-1:0"
  >
    Delete
  </button>
  <button
    class="bfx-button-primary blotter-filter-list__copy"
    [disabled]="selection.length == 0"
    (click)="applySelectedFilters()"
    [tabindex]="isInViewEditMode?-1:0"
  >
    Apply
  </button>
</div>
